import api from './BaseApi';

export const createPOI = async (data) => {
    try {
        const response = await api.post('/admin/poi', data);
        return response; 
    } catch (error) {
        console.error('Create POI error:', error);
        return error;
    }
};

export const getPOIs = async (params) => {
    try {
        const response = await api.get('/admin/poi', { params });
        return response.data;
    } catch (error) {
        console.error('Get poi error:', error);
    }
};

export const updatePOI = async (id, payload) => {
    try {
        const response = await api.put(`/admin/poi/${id}`, payload);
        return response; 
    } catch (error) {
        console.error('Update poi error:', error);
        throw error;
    }
};

export const getSinglePOI = async (id) => {
    try {
        const response = await api.get(`/admin/poi/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get poi error:', error);
    }
};

export const deletePOI = async (id) => {
    try {
        const response = await api.delete(`/admin/poi/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete poi error:', error);
    }
};

export const getAirportsSelection = async (params) => {
    try {
        const response = await api.get('/admin/airport/selection', { params });
        return response.data;
    } catch (error) {
        console.error('Get Airports selection error:', error);
    }
};

export const getConcoursesSelection = async (airportId, params) => {
    try {
        const response = await api.get(`/admin/airport/${airportId}/concourses`, { params });
        return response.data;
    } catch (error) {
        console.error('Get Concourses selection error:', error);
    }
};

export const addPOIImage = async (id, data) => {
    try {
        const response = await api.post(`/admin/poi/${id}/image`, data);
        return response; 
    } catch (error) {
        console.error('Add POI image error:', error);
        return error;
    }
};

export const deletePOIImage = async (id) => {
    try {
        const response = await api.delete(`/admin/poi/image/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete poi image error:', error);
    }
};

export const deleteMainImage = async (id) => {
    try {
        const response = await api.delete(`/admin/poi/${id}/main-image`);
        return response.data;
    } catch (error) {
        console.error('Delete main image error:', error);
    }
};

export const updatePOIStatus = async (payload) => {
    try {
        const response = await api.patch(`/admin/poi/bulk-status`, payload);
        return response; 
    } catch (error) {
        console.error('Update poi status error:', error);
        throw error;
    }
};

export const getPendingImages = async (id) => {
    try {
        const response = await api.get(`/admin/poi/${id}/pending-images`);
        return response.data;
    } catch (error) {
        console.error('Get pending images error:', error);
    }
};

export const approveImage = async (imageIds) => {
    try {
        // Support both single ID and array of IDs
        const ids = Array.isArray(imageIds) ? imageIds : [imageIds];
        const response = await api.put(`/admin/poi/images/approve`, {
            imageIds: ids
        });
        return response.data;
    } catch (error) {
        console.error('Approve image error:', error);
        throw error;
    }
};

export const rejectImage = async (imageIds, reason = '') => {
    try {
        // Support both single ID and array of IDs
        const ids = Array.isArray(imageIds) ? imageIds : [imageIds];
        const response = await api.put(`/admin/poi/images/reject`, {
            imageIds: ids,
            rejection_reason: reason
        });
        return response.data;
    } catch (error) {
        console.error('Reject image error:', error);
        throw error;
    }
};

export const savePOIDynamicFields = async (poiId, dynamicFields) => {
    try {
        const response = await api.post(`/admin/poi/${poiId}/dynamic-fields`, {
            dynamic_fields: dynamicFields
        });
        return response.data;
    } catch (error) {
        console.error('Save POI dynamic fields error:', error);
        throw error;
    }
};

export const getPOIDynamicFields = async (poiId) => {
    try {
        const response = await api.get(`/admin/poi/${poiId}/dynamic-fields`);
        return response.data;
    } catch (error) {
        console.error('Get POI dynamic fields error:', error);
        throw error;
    }
};

export const getPOIReviews = async (poiId) => {
    try {
        const response = await api.get(`/admin/poi/${poiId}/reviews`);
        return response.data;
    } catch (error) {
        console.error('Get POI reviews error:', error);
        return { data: [], result: false, meta: { stats: { average_rating: 0, total_ratings: 0 } } };
    }
};

export const getPOIReports = async (poiId) => {
    try {
        const response = await api.get(`/admin/poi/${poiId}/reports`);
        return response.data;
    } catch (error) {
        console.error('Get POI reports error:', error);
        return { data: [], result: false };
    }
};

export const approvePOIReport = async (reportId, reason) => {
    try {
        const response = await api.put(`/admin/poi/reports/${reportId}/approve`, { reason });
        return response.data;
    } catch (error) {
        console.error('Approve POI report error:', error);
        throw error;
    }
};

export const rejectPOIReport = async (reportId, reason) => {
    try {
        const response = await api.put(`/admin/poi/reports/${reportId}/reject`, { reason });
        return response.data;
    } catch (error) {
        console.error('Reject POI report error:', error);
        throw error;
    }
};
